import styles from './SubmenuLabel.module.css'
import { useTranslations } from 'next-intl'
import NewIcon from '@/assets/img/Icon_ChooseUs.svg'

export enum SubmenuLabelKind {
	NEW = 'new'
}

interface SubmenuLabelProps {
	kind: SubmenuLabelKind,
	callback?: () => void
}

export default function SubmenuLabel({ kind, callback } : SubmenuLabelProps) {
	const t = useTranslations('Label')

	function handleCallback() {
	 callback!()
	}
	
	return (
		<div
			data-testid={`SubmenuLabel_${kind}`}
			className={`${styles.subMenuLabel} ${styles[kind]}`}
			onClick={callback ? handleCallback : undefined}
		>
			{kind === SubmenuLabelKind.NEW &&
			<>
				<NewIcon className={styles.icon} />
				<p className='bodyTextMediumStrong'>{t('new')}</p>
			</>
			}
		</div>
	)
}